import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const uniqueVoucherVoucherListRolesRBAC = {
  pageID: '1b0afec6f908e7152177807ca4fb7256',
  elementID: {
    ViewList: 'a0ada438d155eeb9a719b484ddbc7b60',
    Detail: '776b3e7e258b0a14721cf0c35205f609',
  },
} as const

export const useRBACUniqueVoucherVoucherListPage = createUseRBAC(
  uniqueVoucherVoucherListRolesRBAC.elementID,
)

export type UseRBACUniqueVoucherVoucherListPageType = ReturnType<
  typeof useRBACUniqueVoucherVoucherListPage
>
